import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { useHistory } from 'react-router';

import { Icon } from '@/components/Icon';
import { IconRotate } from '@/components/Icon/types';

import { mergeClassNames } from '@/utils/mergeClassNames';

import styles from './ClientHeader.module.css';

interface ClientHeaderProps {
  title: string;
  backButton?: boolean;
  children?: React.ReactNode;
  titleSlot?: React.ReactNode;
  backTarget?: string;
}

export const ClientOverviewHeader = ({
  title,
  backButton = false,
  children,
  backTarget,
  titleSlot,
}: ClientHeaderProps) => {
  const history = useHistory();

  const goBack = (backTarget: string) => {
    history.push(backTarget);
  };

  return (
    <IonGrid className={styles.header} fixed>
      <IonRow className={mergeClassNames('ion-align-items-center', styles.wrapper)}>
        {backButton && backTarget && (
          <IonCol className={styles.icon} onClick={() => goBack(backTarget)} size='auto'>
            <Icon direction={IconRotate.West} name='chevron' />
          </IonCol>
        )}
        <IonCol
          className={styles.titleCol}
          size={!children && !backButton ? '12' : backButton && !children ? '11' : '7'}>
          <h1 className={styles.title}>{title}</h1>
          {titleSlot}
        </IonCol>
        {children && (
          <IonCol className='ion-no-padding' size='auto' style={{ marginLeft: 'auto' }}>
            {children}
          </IonCol>
        )}
      </IonRow>
    </IonGrid>
  );
};
